import { render, staticRenderFns } from "./WechatCard.vue?vue&type=template&id=a3593d48&"
import script from "./WechatCard.vue?vue&type=script&lang=js&"
export * from "./WechatCard.vue?vue&type=script&lang=js&"
import style0 from "./WechatCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WechatCard.vue"
export default component.exports